import styled from "styled-components";

export const ListItemContainer = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR};
  cursor: pointer;

  &:hover {
    background-color: ${(props) => props.theme.theme.DIVIDER_COLOR};
  }

  .list-icon {
    color: ${(props) => props.theme.theme.CARD.TEXT.TITLE};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .cl-login {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 40px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .list-icon {
      display: none;
    }
  }
`;

export const ListItemImage = styled.img`
  border-radius: 8px;
  height: 100px;
  object-fit: cover;

  @media (max-width: 768px) {
    width: 100%;
    height: 200px;
    margin-bottom: 1rem;
  }
`;
